export enum MOVE_MONEY_ERROR_CODES {
  INSUFFICIENT_GAS_BALANCE = 'INSUFFICIENT_GAS_BALANCE',
}

export const API_FAIL_ERROR_MESSAGE = 'Something went wrong, Please try again';
